module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('vuetable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "showEdit": true,
      "showDelete": true,
      "tableData": _vm.tableData,
      "tableTitle": 'Users',
      "fields": _vm.fields,
      "maxItems": _vm.maxValue
    },
    on: {
      "table-delete-request": _vm.deleteEntity,
      "table-edit-request": _vm.handleEdit,
      "pages-remaining": _vm.loadMore
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa0f8c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/User/UserSearchResults.vue
// module id = 2192
// module chunks = 1